export default __webpack_public_path__ + "static/media/single-border-both.c0f57a87.svg";